import axios from "axios";
/* import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "../../authConfig";
import { msalInstance } from "../.."; */

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_BASE_URL,
  //headers: { Authorization: `Bearer ${localStorage.getItem("Token")}` },
});


instance.defaults.headers.common[
  "Authorization"
] = `Bearer ${localStorage.getItem("IdToken")}`;



/* export const refreshAccessToken = async () => {

  const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  console.log("account", accounts[0]);

  console.log("entrato");
    try {
      msalInstance.acquireTokenSilent({
        scopes: loginRequest.scopes,
        account: accounts[0],
      })
      .then((response) => {
        localStorage.setItem("Token", response.accessToken);
        localStorage.setItem("IdToken", response.idToken);
        console.log("got_new", response.idToken)
        console.log("risposta", response);
        return response.idToken;
      });
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        return msalInstance
          .acquireTokenPopup(loginRequest)
          .then((response) => {
            localStorage.setItem("Token", response.accessToken);
            localStorage.setItem("IdToken", response.idToken);
            return response.idToken;
          })
          .catch((err) => {
            return null;
          });
      } else {
        console.error(error);
      }
    }
  };

instance.interceptors.request.use(
  async () => {
    /* config.headers['x-api-challenge'] =
      localStorage.getItem('challenge') || 'no-key-found';
      console.log("challenge", config.headers['x-api-challenge']) */

    // refreshAccessToken method is the one which makes acquireTokenSilent call .
   /* refreshAccessToken();
    instance.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("IdToken")}`;
  },
  (error) => {Promise.reject(error); console.log(error)}
); */


export default instance;